export enum MessageSender {
    AGENT = 'agent',
    CUSTOMER = 'customer',
    SYSTEM = 'system',
    ERROR = 'error'
}

export interface Message {
    sender: MessageSender;
    text: string;
}

export interface DefaultMessage {
    title: string;
    icon: JSX.Element;
    sample: string;
}

export interface ChatAnswerResponse {
    content: string;
    externalId?: string;
    piiFlag?: boolean;
    question?: string;
}

export interface ChatHistoryDetails {
    inputRequest: string;
    responseText: string;
}

const makeMessage = (sender: MessageSender) => (text: string): Message => ({sender, text});
export const msgOf = {
    customer: makeMessage(MessageSender.CUSTOMER),
    agent: makeMessage(MessageSender.AGENT),
    system: makeMessage(MessageSender.SYSTEM),
    error: makeMessage(MessageSender.ERROR),
};